<div class="content-pane readable">
  <div class="content">
    <div class="content-body">
      <div class="content-main">
        @if (resource()?._can_edit) {
          <div class="meta-header">
            <h3>Resource Details</h3>
            <span class="action-button">
              <a [routerLink]="['/resource-explorer/edit-details', resource().id]" mat-button>
                <mat-icon class="material-symbols-outlined">edit</mat-icon>
                Edit
              </a>
            </span>
          </div>
        }
        <div class="content-icon">
          <mat-icon title="{{ resource()?.icon?.name }}" class="material-symbols-outlined standard-icon">
            {{ resource().icon?.symbol }}
          </mat-icon>
        </div>
        <div class="content-container">
          <div class="content-header">
            <h2 class="content-title">{{ resource().name }}</h2>
          </div>
          <div class="content-toolbar">
            @if (normalizeURL() !== '') {
              <a [href]="normalizeURL()" target="_blank" rel="noopener" class="content-header-action toolbar-action">
                <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
                Visit Website
              </a>
            }

            @if (isEventResource()) {
              <a
                class="addeventatc content-header-action toolbar-action mat-mdc-button mat-mdc-button-base"
                title="Add to Calendar"
              >
                <mat-icon class="material-symbols-outlined">event</mat-icon>
                Add to Calendar
                <span class="start">
                  {{ event()?.event_metadata?.starts | date: 'yyyy-MM-ddTHH:mm:ss' : 'UTC' }}
                </span>
                <span class="end">
                  {{ event()?.event_metadata?.ends | date: 'yyyy-MM-ddTHH:mm:ss' : 'UTC' }}
                </span>
                <span class="title">{{ event()?.name }}</span>
                <span class="description">{{ event()?.description }}</span>
                <span class="location">{{ event()?.event_metadata?.location }}</span>
                <span class="timezone">UTC</span>
              </a>
            }

            @if (user) {
              <a class="content-header-action toolbar-action" (click)="toggleFavorite()">
                @if (isFavoritedByUser()) {
                  <mat-icon>favorite</mat-icon>
                } @else {
                  <mat-icon class="material-symbols-outlined">favorite</mat-icon>
                }
                {{ isFavoritedByUser() ? 'Remove from Favorites' : 'Add to Favorites' }}
              </a>
            }
          </div>

          @if (isEventResource()) {
            <div class="event-metadata">
              <div [innerHTML]="event().event_metadata | eventMetadata: false : event().event_metadata?.location"></div>
            </div>
          }

          <div class="description" [innerHTML]="safeDescription()"></div>
          <div class="meta-subcontent">
            <app-key-value-table [rowsToDisplay]="resourceTableData()"></app-key-value-table>
          </div>

          <app-resource-attachments [resource]="resource()"></app-resource-attachments>
        </div>
      </div>
      <div class="content-sidebar">
        @if (resource()._can_edit) {
          <div class="access-section">
            <div class="meta-header">
              <h3>Resource Access</h3>
              <span class="action-button">
                <a [routerLink]="['/resource-explorer/edit-access', resource().id]" mat-button>
                  <mat-icon class="material-symbols-outlined">edit</mat-icon>
                  Edit
                </a>
              </span>
            </div>
            <div class="meta-subheader">Visibility of Resource Details</div>
            <div class="meta-subcontent">
              <span>
                <b>{{ resource().visible_to_all_users ? 'All Users' : 'Owners only' }}</b>
              </span>
            </div>
            <div class="meta-subheader">Recommended Audience</div>
            <div class="meta-subcontent">
              <span><b>Curated for: </b></span>
              <span>{{ audienceResolver(resource().target_audiences) }}</span>
            </div>
            <div class="meta-subheader">Resource Permissions</div>
            <div class="meta-subcontent">
              <span><b>Owners: </b></span>
              <ul class="inline-list">
                @for (owner of resource().owners; track owner.email) {
                  <li [title]="owner.email">{{ owner.email }}</li>
                }
              </ul>
            </div>
            <div class="actions resource">
              <a
                [routerLink]="['/resource-explorer/edit-access', resource().id, {subsection: 'delete'}]"
                matButton="filled"
                class="delete"
              >
                <mat-icon class="material-symbols-outlined">delete</mat-icon>Delete
              </a>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
